import React, { useEffect } from "react";
import styled from "styled-components";
import { logEvent } from "firebase/analytics";
import { useHistory } from "react-router-dom";
import analytics from "../../../context/analytics";

import {
  Button,
  StyledText,
  MainHolder,
  Children,
  Body,
  DynamicButton,
} from "../../../components/common/basic";
import { BackButton, FeatureHeader } from "../../../components/common";
import { useLoyalty, useTheme } from "../../../hooks";

const AyobaHome = () => {
  useEffect(() => {
    analytics().then(anl => logEvent(anl, "screen_view", {
      firebase_screen: "AyobaHome",
      firebase_screen_class: "AyobaHome",
    }));
  }, []);
  const history = useHistory();
  const { selectedLoyaltyData } = useLoyalty();
  const { logo, footer, link } = selectedLoyaltyData;

  const { themeContext, theme } = useTheme();
  let themeColor = "background";
  let background = theme.colors[themeContext.activeTheme][themeColor];

  return (
    <>
      <MainHolder>
        <Children>
          <BackButton onClick={() => history.goBack()} />
          <Body>
            <div style={{ boxSizing: 'border-box', padding: '10px 15px 20px 15px' }}>
              <AyobaWrapper>
                <div>
                  <img src={logo} style={{ width: '120px' }} />
                  <div style={{ width: '272px' }}>
                    <StyledText
                      margin={0}
                      size={24}
                      style={{ margin: '10px 0 20px 0' }}
                      color={'#06569B'}
                    >
                      Simple, secure and seamless messaging
                    </StyledText>

                    <StyledText margin={0} size={14} style={{ fontFamily: 'MTNRegular' }}>
                      Ayoba is a free messaging app for your andoid mobile phone.
                    </StyledText>
                    <StyledText size={14} style={{ fontFamily: 'MTNRegular', margin: '5px 0 30px 0' }}>
                      Chat with your friends, listen to free music, transfer money and much more!
                    </StyledText>

                    <img src={footer} style={{ marginBottom: '20px' }} />

                    <DynamicButton
                      onClick={() => {
                        window.open(link);
                      }}
                      label="Go to Ayoba"
                      color={background}
                      fullWidth
                    />
                  </div>
                </div>
              </AyobaWrapper>
            </div>
          </Body>
        </Children>
      </MainHolder>
    </>
  );
};

const AyobaWrapper = styled.div`
  text-align: center;
  width: 100%;
  box-sizing: border-box;
  display: flex;
  height: 90vh;
  justify-content: center;
  align-items: center;
`;

export default AyobaHome;
